export const SET_CACHED_CHART = "SET_CACHED_CHART";
export const RESET_CACHED_CHARTS = "RESET_CACHED_CHARTS";
